import { useMutation } from '@tanstack/react-query';
import { aemApi } from 'global/API/aemApi';

import {
  UseCheckMarketingOptinMutationResponse,
  UseCheckMarketingOptinMutationError,
  UseCheckMarketingOptinMutationBody,
} from './useOptinStatusMutation.interface';

export const USE_GLOBAL_OPTIN_STATUS_MUTATION_KEY =
  'Global_check_marketing_optin_mutation';

const postCheckMarketingOptin = async ({
  taxvat,
}: UseCheckMarketingOptinMutationBody) => {
  const { data } = await aemApi.post<UseCheckMarketingOptinMutationResponse>(
    process.env.REACT_APP_SERVLET_CHECK_OPTIN_STATUS ?? '',
    { taxvat },
    { headers: { 'Content-Type': 'application/json' } }
  );

  return data;
};

export const useCheckMarketingOptinMutation = () => {
  return useMutation<
    UseCheckMarketingOptinMutationResponse,
    UseCheckMarketingOptinMutationError,
    UseCheckMarketingOptinMutationBody
  >({
    mutationKey: [USE_GLOBAL_OPTIN_STATUS_MUTATION_KEY],
    mutationFn: postCheckMarketingOptin,
    retry: 1,
  });
};
